import React from "react";
import UseCaseTemplate from "./UseCaseTemplate";
import media1 from "./assets/media/media1.jpg";
import media1a from "./assets/media/media1_1.jpg";
import media2 from "./assets/media/media2.jpg";
import media3 from "./assets/media/media3.jpg";
import media2Video from "./assets/media/media2.mp4";
import media3Video from "./assets/media/media3.mp4";

const experiences = [
  {
    id: "breaking-news",
    number: "01",
    category: "Crisis & breaking news",
    title: "Nepal Flash Floods: Verified Field Intel",
    lead: "Turn local eyewitness smartphone feeds into an AI-synchronized, multi-angle breaking-news mosaic with contributor rights and payout built in.",
    layout: "Symphony",
    layoutDetail: "Four synchronized field and studio feeds",
    workflowTitle: "Himalaya Emergency weave",
    workflow: [
      "An isolated villager upstream of the mudslide.",
      "A resident in the flooded valley.",
      "A studio weather-desk analysis.",
      "Live satellite flood tracking.",
      "Synchronize the sources into one verified multi-angle story while production crews are still unable to reach the area.",
    ],
    outcome1Label: "Media impact",
    outcome1: "Verified on-the-ground footage can support global exclusives, immediate B2B syndication to wire services and lower heavy-logistics overhead.",
    outcome2Label: "Weaver monetization",
    outcome2: "Local eyewitnesses receive direct Smart Escrow payouts upon broadcast while retaining ownership, attribution and payment rights instead of being scraped anonymously from social media.",
    image: media1,
  },
  {
    id: "weekly-living-doc",
    number: "02",
    category: "Documentary",
    title: "The Weekly Living Doc",
    lead: "Turn one documentary premiere into an evolving serial that refreshes weekly without re-rendering, re-uploading or breaking links.",
    layout: "Storyboard",
    layoutDetail: "Persistent root URL with weekly hot-swapping",
    workflowTitle: "Compounding documentary timeline",
    workflow: [
      "Week 1: publish the 10-minute cinematic master on the root URL.",
      "Week 2: hot-swap a 60-second post-broadcast reaction into Slot 2.",
      "Week 3: inject exclusive evidence or rebuttal from field Weavers.",
      "Week 4+: refresh the player with breaking legal or scientific updates.",
      "Connection AI aligns new smartphone submissions with the original master; Generation AI updates subtitles, chapter markers and recap cards.",
    ],
    outcome1Label: "Media impact",
    outcome1: "The supplied concept targets 5x viewer return by converting a one-time impression into recurring attention on the exact same link.",
    outcome2Label: "Weaver monetization",
    outcome2: "Smart Escrow routes automated micro-royalties to verified contributors, fixers and journalists as their slots gain views.",
    image: media2,
    video: media2Video,
  },
  {
    id: "global-polyphonic-doc",
    number: "03",
    category: "Decentralized production",
    title: "Le Documentaire Polyphonique Mondial",
    lead: "Direct an international film remotely through a pre-structured visual architecture populated by local creators around the world.",
    layout: "Storyboard",
    layoutDetail: "Modular global production canvas on one persistent URL",
    workflowTitle: "From script to decentralized production",
    workflow: [
      "The showrunner defines a narrative backbone with thematic and geographic slots.",
      "Accredited creators around the world submit footage directly into assigned editorial slots.",
      "The director reviews and hot-swaps the best takes without re-exporting a master file or changing the root link.",
      "Connection AI harmonizes camera sources, sound beds and verified GPS/timestamp metadata.",
      "Generation AI creates synchronized multilingual subtitles and animated transit maps.",
    ],
    outcome1Label: "Business impact",
    outcome1: "The supplied concept targets a 5x production-cost reduction by eliminating international travel, reducing carbon impact and shortening footage-sorting work.",
    outcome2Label: "Weaver monetization",
    outcome2: "Smart Escrow can release $150–$500 bounties in the supplied concept or activate downstream streaming rev-shares as soon as a contribution is approved.",
    image: media3,
    video: media3Video,
  },
];

export default function MediaPage() {
  return (
    <UseCaseTemplate
      pageTitle={"Media"}
      currentPath={"/use-cases/media"}
      eyebrow={"WEAVEVO USE CASE · MEDIA"}
      heroTitle={"Turn field reporting into living, evolving media."}
      heroText={"Combine verified eyewitness footage, weekly documentary updates and decentralized global production into persistent media assets that keep the same URL while the story develops."}
      heroAlt={"Newsroom and field media connected through Weavevo"}
      finalEyebrow={"BUILD THE NEXT MEDIA WEAVE"}
      finalTitle={"The story should keep evolving after the first publish."}
      finalText={"Use verified field contributions, hot-swappable documentary slots and automated rights flows to build media that compounds instead of expiring in the feed."}
      heroImage={media1}
      experiences={experiences}
    />
  );
}
